function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($component, JSON, Object) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    return {
      value: (h("div", {
        "class": {
          'create-annotations-button-container': true,
          'active': $component.isAttributeEnabled(`active`)
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("svg-icon", {
          "attrs": __vjadeStringifyAttrsIfObj({
            icon: `plus`
          }),
        }));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;